import type React from "react"
import { Box, Container, Typography, Grid, Button } from "@mui/material"
import ContactForm from "../molecules/ContactForm"

const ContactSection: React.FC = () => {
  return (
    <Box
      id="contact"
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: "primary.main",
        color: "white",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={5}>
            <Typography variant="h2" component="h2" gutterBottom>
              Ready to Find Your Perfect Match?
            </Typography>
            <Typography variant="h6" sx={{ mb: 4, opacity: 0.9 }}>
              Join thousands of satisfied families who have found reliable cooks and maids through our platform.
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              sx={{
                fontWeight: "bold",
                fontSize: "1rem",
                px: 4,
                py: 1.5,
              }}
            >
              Post Your Requirement
            </Button>
          </Grid>
          <Grid item xs={12} md={7}>
            <Box
              sx={{
                bgcolor: "rgba(255, 255, 255, 0.1)",
                p: 4,
                borderRadius: 2,
              }}
            >
              <Typography variant="h4" component="h3" gutterBottom>
                Contact Us
              </Typography>
              <ContactForm />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default ContactSection
